import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import axios from "axios";
import { getFunctions, httpsCallable } from "firebase/functions";

const querySnapshot = collection(db, "routePartnerMainAddress");
export const getWareHouses = (conditions) => {
  const whereConditions = Object.keys(conditions).map((key) =>
    where(key, "==", conditions[key])
  );
  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, async (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
      // setFilterOptions(prev=>({...prev,warehouses:arr}));
    });
  });
};

export const getWareHouseById = async (id) => {
  const docRef = doc(db, "routePartnerMainAddress", id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
}

export const getRoutePartners = (conditions) => {
  const querySnapshot = collection(db, "routePartners");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    condition.push(where(cd.key, `${cd.operator}`, cd.value));
  });
  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getUserDetailsById = async (userId) => {
  if (!userId) return null;
  const userDocSnap = await getDoc(doc(db, "users", userId));
  if (userDocSnap.exists()) {
    return userDocSnap.data();
  }
  return null;
};

export const getOnlySuites = async (conditions) => {
  console.log(conditions, "conditionssss");
  const querySnapshot = collection(db, "mySuites");
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  const q = query(querySnapshot, ...whereConditions);
  try {
    const snapshot = await getDocs(q);
    const arr = [];
    snapshot.forEach((doc) => {
      arr.push({ ...doc.data(), id: doc.id });
    });
    console.log(arr, "final data");
    return arr;
  } catch (error) {
    console.error("Error fetching suites:", error);
    throw error;
  }
};

export const getAllSuites = (conditions) => {
  const querySnapshot = collection(db, "mySuites");
  const condition = [];
  console.log(conditions, "Conditions");

  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, async (snapshot) => {
      const arr = [];

      for (const docSnapshot of snapshot.docs) {
        const mapUserData = docSnapshot.data();
        if (mapUserData.userId) {
          const user = await getUserDetailsById(mapUserData.userId);
          if (user) {
            arr.push({ ...mapUserData, ...user, id: docSnapshot.id });
          } else {
            arr.push({ ...mapUserData, id: docSnapshot.id });
          }
        }
      }
      resolve(arr);
    });
  });
};

export const getShelfPackages = (conditions) => {
  const querySnapshot = collection(db, "shelfPackages");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getShelfConsolidatedPackages = (conditions) => {
  const querySnapshot = collection(db, "shelfConsolidatedPackages");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getDetailsById = (conditions, collectionName) => {
  const querySnapshot = collection(db, collectionName);
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
}

export const getShelfShoppingPackages = (conditions) => {
  const querySnapshot = collection(db, "shelfShoppingPackages");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getBrands = (conditions = []) => {
  const querySnapshot = collection(db, "brands");
  const condition = [];
  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  console.log(whereConditions, "whereConditions");

  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
};

export const getAllItems = async (itemIds) => {
  // console.log(itemIds,"itemIdsitemIds")
  const items = itemIds.map(async (id) => {
    const docRef = doc(db, "items", id);
    const itemDoc = await getDoc(docRef);
    if (itemDoc.exists()) {
      return itemDoc.data();
    }
  });
  console.log(items, "itemsitems");

  return await Promise.all(items);
};

export const getMySuiteDetails = async (suitId) => {
  const docRef = doc(db, "mySuites", suitId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
};

export const updateMySuiteDetails = async (suitId, data) => {
  const docRef = doc(db, "mySuites", suitId);
  return await updateDoc(docRef, data);
};

export const getUserCounts = async (userId) => {
  const q1 = query(collection(db, "mySuites"), where("userId", "==", userId));
  const querySnapshot1 = await getDocs(q1);
  return querySnapshot1.size;
};

export const updateShelfPackageDetails = async (packageId, data) => {
  console.log(packageId, data, "packageId, data");

  const docRef = doc(db, "shelfPackages", packageId);
  return await updateDoc(docRef, data);
};

export const updateShelfShoppingPackageDetails = async (packageId, data) => {
  console.log(packageId, data, "details about package");

  const docRef = doc(db, "shelfShoppingPackages", packageId);
  return await updateDoc(docRef, data);
};

export const updateItemDetails = async (itemId, data) => {
  console.log(itemId,data,"all derfsdfsdf");
  
  const docRef = doc(db, "items", itemId);
  return await updateDoc(docRef, data);
};

export const addNewShelfPackage = async (data) => {
  const packageSettings = await getDoc(doc(db, "masterData", "packageSetting"));

  if (packageSettings.exists()) {
    const docData = packageSettings.data();
    console.log(docData, data, "docData");

    const docRef = doc(
      db,
      "shelfPackages",
      `PACK-${docData.currentId.toString()}`
    );
    setDoc(docRef, {
      ...data,
      id: docRef.id,
      packageTrackingId: docRef.id,
    }).then(async (res) => {
      await updateDoc(doc(db, "masterData", "packageSetting"), {
        currentId: docData.currentId + docData.incrementBy,
      });
      return res;
    });
  } else {
    return null;
  }
};

export const getMasterData = async () => {
  const masterDataRef = doc(db, "masterData", "packageSetting");
  const masterData = await getDoc(masterDataRef);
  return masterData.data();
};

export const updateMasterData = async (data) => {
  const masterDataRef = doc(db, "masterData", "packageSetting");
  return await updateDoc(masterDataRef, data);
}

export const getLatestShelfPackage = async (mySuiteId) => {
  const latestPackageQuery = query(
    collection(db, "shelfPackages"),
    where("arrivedAt", "!=", null),
    where("mySuiteId", "==", mySuiteId),
    orderBy("arrivedAt", "desc"),
    limit(1)
  );
  const latestPackageSnapshot = await getDocs(latestPackageQuery);
  return latestPackageSnapshot.empty ? null : latestPackageSnapshot.docs[0].data();
};

export const getAddons = async (conditions) => {
  const querySnapshot = collection(db, "mySuiteAddOns");
  console.log(conditions, "conditionsconditions");

  const whereConditions = conditions.map((cd) => {
    return where(cd.key, `${cd.operator}`, cd.value);
  });
  const q = query(querySnapshot, ...whereConditions);
  return new Promise((resolve, reject) => {
    onSnapshot(q, (snapshot) => {
      const arr = [];
      snapshot.forEach((doc) => {
        arr.push({ ...doc.data(), id: doc.id });
      });
      resolve(arr);
    });
  });
}

export const getItem = async (itemId) => {
  const docRef = doc(db, "items", itemId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
}

export const getFormDetails = async (itemId) => {
  console.log(itemId, "itemId in getFormDetails");

  const docRef = doc(db, 'forms', itemId);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data()
  }
  return null;
}

export const getPostpalMarkups = async () => {
  const markups = await axios.get(`https://getcouriers-kh7okbs2hq-uc.a.run.app?routePartnerId=611180`);
  console.log(markups, "dsdadfadsdaf");
  return markups?.data?.couriers
}

export const getWarehousesCloud = async () => {
  const warehouses = await axios.get("https://getroutepartnermainaddresses-kh7okbs2hq-uc.a.run.app");
  console.log(warehouses, "dsdadfadf");

  return warehouses?.data?.addresses
}

export const updateItemsDetails = async (payload) => {
  const updatedItem = await axios.post("https://updateshoppingitemprice-kh7okbs2hq-uc.a.run.app", payload);

  return updatedItem;
}
export const sendNotification = async (userId, title, body, details,actionText) => {
  const user = await getUserDetailsById(userId);
  console.log(user, "sjjdfjdnf");
  const notificationPayload = {
    body: body,
    desc: "",
    identifier: details?.number,
    isRead: false,
    sentOn: serverTimestamp(),
    title: title,
    type: details?.type,
    userId: userId,
    actionText:actionText||""
  }
  console.log(notificationPayload,"notificationPayload");
  
  const notification = await addDoc(collection(db, "notifications"), notificationPayload);
  if(user?.fcmToken){
    const payload = {
      token: user?.fcmToken,
      title: title,
      body: body,
      data: {
        identifier: details?.number,
        type: details?.type
      }
    }
    const sendNoti = await axios.post("https://sendpushnotification-c3ryyxocoa-uc.a.run.app", payload)
  }
}

export const sendMail = async (data) => {
  const functions = getFunctions();
  const callableReturnMessage = httpsCallable(functions, "sendEmail");
  return await callableReturnMessage({
    email: data.email,
    subject: data.subject,
    content: data.content,
  })
}

export const generateReceiveMail = (data)=>{
  const mess = `Hello ${data?.name}
We are excited to inform you that your package with UPS tracking number: ${data?.trackingNumber} has arrived at our warehouse and has been assigned the Package ID: ${data?.packageId} .
_________________________________________________________________________________________________________________

 Important Note:
Your package is now available on your shelf under "packages".
__________________________________________________________________________________________________________________

Next Steps: Request “Prepare Shipment” 
     1.Open the app and navigate to "My Suite" from the homepage.
     2.Go to your "Shelf" and locate Package ID: {Pack_ID} .
     3.Click to open the package details.

You’ll be able to request for your package to be “Prepared for Shipment”.
___________________________________________________________________________________________________________________

Additional Services You Might Love:

      Item Add-ons
      Request extra services like:
          More photos
          Condition check
          Check Measurements
          …and more!
      Package Add-ons
      Personalize your shipment with options like:
          Record My Shipment
          Remove Price Tag
          …and so much more!
___________________________________________________________________________________________________________________

We look forward to getting your package ready and on its way! 
Happy Shipping with POSTPAL!
___________________________________________________________________________________________________________________

Thank you for choosing POSTPAL,

Your team @POSTPAL `

const mess1 = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Package Arrival Notification</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      color: #333;
      line-height: 1.6;
    }
    .container {
      max-width: 600px;
      margin: auto;
      padding: 20px;
      border: 1px solid #eaeaea;
      border-radius: 8px;
      background-color: #f9f9f9;
    }
    h2 {
      color: #2c3e50;
    }
    .note, .services {
      margin-top: 20px;
    }
    ul {
      padding-left: 20px;
    }
    .footer {
      margin-top: 30px;
      font-size: 0.9em;
      color: #888;
    }
  </style>
</head>
<body>
  <div class="container">
    <h2>Hello ${data?.name},</h2>

    <p>We are excited to inform you that your package with ${data?.logisticPartner||""} tracking number: <strong>${data?.trackingNumber}</strong> has arrived at our warehouse and has been assigned the Package ID: <strong>${data?.packageId}</strong>.</p>

    <div class="note">
      <h4>Important Note:</h4>
      <p>Your package is now available on your shelf under <strong>"packages"</strong>.</p>
    </div>

    <div class="next-steps">
      <h4>Next Steps: Request “Prepare Shipment”</h4>
      <ol>
        <li>Open the app and navigate to "My Suite" from the homepage.</li>
        <li>Go to your "Shelf" and locate Package ID: <strong>${data?.packageId}</strong>.</li>
        <li>Click to open the package details.</li>
        <li>You’ll be able to request for your package to be “Prepared for Shipment”.</li>
      </ol>
    </div>

    <div class="services">
      <h4>Additional Services You Might Love:</h4>
      <p><strong>Item Add-ons</strong><br>
      Request extra services like:</p>
      <ul>
        <li>More photos</li>
        <li>Condition check</li>
        <li>Check Measurements</li>
      </ul>

      <p><strong>Package Add-ons</strong><br>
      Personalize your shipment with options like:</p>
      <ul>
        <li>Record My Shipment</li>
        <li>Remove Price Tag</li>
        <li>…and so much more!</li>
      </ul>
    </div>

    <div class="footer">
      <p>We look forward to getting your package ready and on its way!<br>
      Happy Shipping with POSTPAL!</p>

      <p>Thank you for choosing POSTPAL,<br>
      Your team @POSTPAL</p>
    </div>
  </div>
</body>
</html>
`

return mess1;
}

export const generateReceiveMailForNotHaveItems = (data) => {
    const mess = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Action Required: Add Items to Your Package</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      color: #333;
      line-height: 1.6;
    }
    .container {
      max-width: 600px;
      margin: auto;
      padding: 20px;
      border: 1px solid #eaeaea;
      border-radius: 8px;
      background-color: #f9f9f9;
    }
    h2 {
      color: #2c3e50;
    }
    .section {
      margin-top: 20px;
    }
    ul, ol {
      padding-left: 20px;
    }
    .footer {
      margin-top: 30px;
      font-size: 0.9em;
      color: #888;
    }
  </style>
</head>
<body>
  <div class="container">
    <h2>Hello ${data?.name},</h2>

    <p>We are excited to inform you that your package with tracking number: <strong>${data?.trackingNumber}</strong> has arrived at our warehouse and has been assigned the Package ID: <strong>${data?.packageId}</strong>.</p>

    <div class="section">
      <h4>Important Note:</h4>
      <p>Your package does not have any items listed.</p>
    </div>

    <div class="section">
      <h4>Action Required:</h4>
      <p><strong>You MUST enter the item(s)</strong> of your package before requesting us to prepare it for shipment.</p>
      <p><em>Why?</em><br>This information is essential to complete your customs declaration forms.</p>
    </div>

    <div class="section">
      <h4>Next Steps: Request “Prepare Shipment”</h4>
      <ol>
        <li>Open the app and navigate to "My Suite" from the homepage.</li>
        <li>Go to your "Shelf" and locate Package ID: <strong>${data?.packageId}</strong>.</li>
        <li>Click to open the package details.</li>
        <li>Tap the “+” icon at the bottom of your screen to add items:
          <ul>
            <li>Manually Add Items</li>
            <li>Add Items from Store</li>
          </ul>
        </li>
        <li>Once you’ve added your items, you’ll be able to request for your package to be “Prepared for Shipment”.</li>
      </ol>
    </div>

    <div class="section">
      <h4>Additional Services You Might Love:</h4>
      <p><strong>Item Add-ons</strong><br>Request extra services like:</p>
      <ul>
        <li>More photos</li>
        <li>Condition check</li>
        <li>Check Measurements</li>
      </ul>

      <p><strong>Package Add-ons</strong><br>Personalize your shipment with options like:</p>
      <ul>
        <li>Record My Shipment</li>
        <li>Remove Price Tag</li>
        <li>…and so much more!</li>
      </ul>
    </div>

    <div class="footer">
      <p>We look forward to getting your package ready and on its way!<br>
      Happy Shipping with POSTPAL!</p>

      <p>Thank you for choosing POSTPAL,<br>
      Your team @POSTPAL</p>
    </div>
  </div>
</body>
</html>
`

return mess;
}